import React from 'react';
import { Label, PADDING_CONTAINER_HORIZONTAL } from '../styledComponents';
import { PaddingContainer } from '../styledComponents';
import useExploreStore from '@/stores/useExploreStore';
import PreferenceButton from '@/shared/components/PreferenceButton';
import styled, { css } from '@emotion/native';
import { format, isSameDay } from 'date-fns';
import { BodyText } from '@/shared/components/StyledText';
import { green, mintGreenAlt } from '@/shared/styles/colors';
import { ActivityIndicator, useWindowDimensions } from 'react-native';
import { AvailableTime } from '../BookCalendar';

interface Props {
  loading: boolean;
  availableTimes: AvailableTime[];
}

const SelectTime = ({ loading, availableTimes }: Props) => {
  const { booking, setBooking } = useExploreStore();
  const { width: screenWidth } = useWindowDimensions();

  const onToggle = (time: AvailableTime) => {
    if (!booking.selectedDate) {
      return;
    }
    const date = new Date(booking.selectedDate);
    const timeDate = new Date(time.value);
    date.setHours(timeDate.getHours(), timeDate.getMinutes(), 0, 0);

    setBooking({
      selectedTime: time.value.getTime(),
      selectedDate: date,
    });
  };

  const filteredAvailableTimes = availableTimes.filter((time) => {
    if (!booking.selectedDate) {
      return true;
    }
    return isSameDay(time.value, booking.selectedDate);
  });

  const GAP = 16;
  const dynamicButtonWidth =
    (screenWidth - GAP - PADDING_CONTAINER_HORIZONTAL * 2) / 2;

  return (
    <PaddingContainer marginBottom={24}>
      <Label marginBottom={12}>Select the time:</Label>
      <DisplayDateContainer>
        <DisplayDate>
          {booking.selectedDate
            ? format(booking.selectedDate, 'EEEE, MMMM d, yyyy')
            : 'Select a Date'}
        </DisplayDate>
      </DisplayDateContainer>
      <TimeContainer gap={GAP}>
        {loading ? (
          <LoadingContainer>
            <ActivityIndicator color={green} />
          </LoadingContainer>
        ) : (
          filteredAvailableTimes.map((time) => (
            <PreferenceButton
              key={time.value.getTime()}
              item={time.label}
              isSelected={booking.selectedTime === time.value.getTime()}
              isDesktop={false}
              onToggle={() => {
                onToggle(time);
              }}
              buttonStyle={[buttonStyle, { width: dynamicButtonWidth }]}
              textStyle={{ fontSize: 14 }}
            />
          ))
        )}
      </TimeContainer>
    </PaddingContainer>
  );
};

const TimeContainer = styled.View<{ gap: number }>(({ gap }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: gap,
}));

const DisplayDateContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: mintGreenAlt,
  marginBottom: 24,
  paddingVertical: 10,
});

const DisplayDate = styled(BodyText)({
  fontSize: 14,
  lineHeight: 18.9,
  fontWeight: 'bold',
  color: green,
});

const buttonStyle = css({
  height: 62,
  marginBottom: 0,
  paddingHorizontal: 18,
});

const LoadingContainer = styled.View({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export default SelectTime;
